module.exports = __webpack_public_path__ + "img/更换周期.2a45860d.svg";